let MarkerClusterer = require('./markerclusterer');

module.exports = {
    MarkerClusterer
}


// WEBPACK FOOTER //
// ./node_modules/tortilla/src/maps/markers/index.js